import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withKeys as _withKeys, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-lg-row" }
const _hoisted_2 = { class: "card card-flush" }
const _hoisted_3 = {
  class: "card-header pt-7",
  id: "kt_chat_contacts_header"
}
const _hoisted_4 = { class: "d-flex flex-row w-100" }
const _hoisted_5 = {
  class: "w-100 position-relative flex-fill",
  autocomplete: "off"
}
const _hoisted_6 = {
  value: "all",
  selected: ""
}
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-repeat fs-2" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  class: "card-body pt-5",
  id: "kt_chat_contacts_body"
}
const _hoisted_11 = {
  key: 0,
  class: "scroll-y me-n5 pe-5",
  style: {"min-height":"400px !important","max-height":"90vh !important"},
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_header, #kt_toolbar, #kt_footer, #kt_chat_contacts_header",
  "data-kt-scroll-wrappers": "#kt_content, #kt_chat_contacts_body",
  "data-kt-scroll-offset": "0px"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "symbol symbol-40px symbol-circle" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "ms-5" }
const _hoisted_17 = { class: "fs-7 fw-bolder text-gray-900 text-hover-primary mb-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "text-muted fs-7 fw-lighter mb-1" }
const _hoisted_20 = { class: "d-flex flex-column align-items-end ms-2" }
const _hoisted_21 = { class: "fw-lighter text-gray-400 fs-7" }
const _hoisted_22 = {
  key: 0,
  class: "card",
  id: "kt_chat_messenger"
}
const _hoisted_23 = {
  class: "card-header",
  id: "kt_chat_messenger_header"
}
const _hoisted_24 = { class: "card-title" }
const _hoisted_25 = { class: "d-flex justify-content-center flex-column me-3" }
const _hoisted_26 = {
  key: 0,
  class: "symbol-group symbol-hover"
}
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<div class=\"symbol symbol-35px symbol-circle\"><img alt=\"Pic\" src=\"/media/avatars/150-4.jpg\"></div><div class=\"symbol symbol-35px symbol-circle\"><img alt=\"Pic\" src=\"/media/avatars/150-15.jpg\"></div><a href=\"#\" class=\"symbol symbol-35px symbol-circle\" data-bs-toggle=\"modal\" data-bs-target=\"#kt_modal_view_users\"><span class=\"symbol-label fs-8 fw-bolder\" data-bs-toggle=\"tooltip\" data-bs-trigger=\"hover\" title=\"\" data-bs-original-title=\"View more users\">+42</span></a>", 3)
const _hoisted_30 = [
  _hoisted_27
]
const _hoisted_31 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_32 = { class: "symbol symbol-40px symbol-circle" }
const _hoisted_33 = ["src"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "symbol-badge bg-success start-115 top-100 border-4 h-15px w-15px ms-n2 mt-n2" }, null, -1)
const _hoisted_35 = { class: "d-flex flex-column ms-5" }
const _hoisted_36 = { class: "fs-4 fw-bolder text-gray-900 text-hover-primary me-1 mb-2 lh-1" }
const _hoisted_37 = { class: "card-toolbar" }
const _hoisted_38 = { class: "me-n3" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-repeat fs-2" }, null, -1)
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left fs-2" }, null, -1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = {
  class: "card-body pb-0",
  id: "kt_chat_messenger_body"
}
const _hoisted_44 = {
  key: 0,
  class: "scroll-y me-n5 pe-5 d-flex flex-column-reverse justify-content-start",
  id: "kt_chat_scroll_admin",
  ref: "messagesRef",
  "data-kt-element": "messages",
  "data-kt-scroll": "true",
  "data-kt-scroll-dependencies": "#kt_header, #kt_toolbar, #kt_footer, #kt_chat_messenger_header, #kt_chat_messenger_footer",
  "data-kt-scroll-wrappers": "#kt_content, #kt_chat_messenger_body",
  "data-kt-scroll-offset": "-2px",
  style: {"height":"50vh !important"}
}
const _hoisted_45 = {
  key: 0,
  class: "card-footer pt-4",
  id: "kt_chat_messenger_footer"
}
const _hoisted_46 = ["placeholder"]
const _hoisted_47 = { class: "d-flex flex-stack" }
const _hoisted_48 = { class: "el-upload__tip d-none" }
const _hoisted_49 = { class: "d-flex" }
const _hoisted_50 = ["title"]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-paperclip fs-3" }, null, -1)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = ["title"]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-image fs-3" }, null, -1)
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = ["title"]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-camera-video fs-3" }, null, -1)
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = ["title"]
const _hoisted_60 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-mic fs-3" }, null, -1)
const _hoisted_61 = [
  _hoisted_60
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_Date = _resolveComponent("Date")!
  const _component_Notice = _resolveComponent("Notice")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_MessageIn = _resolveComponent("MessageIn")!
  const _component_MessageOut = _resolveComponent("MessageOut")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      style: _normalizeStyle(`${
        _ctx.mobileUiChat === true && _ctx.activeBox === false ? 'display:none' : ''
      }`),
      class: "flex-column flex-lg-row-auto w-100 w-lg-300px w-xl-400px mb-10 mb-lg-0"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("form", _hoisted_5, [
              _withDirectives(_createElementVNode("select", {
                class: "form-select form-select-solid",
                "aria-label": "Select example",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedBot) = $event))
              }, [
                _createElementVNode("option", _hoisted_6, _toDisplayString(_ctx.translate("All my whatsapp")), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bots, (item, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: index,
                    value: item.bot_id
                  }, _toDisplayString(item.name), 9, _hoisted_7))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectedBot]
              ])
            ]),
            _createVNode(_component_el_tooltip, {
              placement: "right",
              content: _ctx.translate('Update')
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-icon btn-hover-scale bg-hover-primary btn-active-light-primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => {
                  _ctx.page = 1;
                  _ctx.getConversations();
                })
                }, _hoisted_9)
              ]),
              _: 1
            }, 8, ["content"])
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_ctx.filterData && _ctx.filterData.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterData, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    onClick: ($event: any) => {
                  _ctx.files ? _ctx.fileInputKey++ : '', (_ctx.activeBox = false);
                  _ctx.lastMessageId = null;
                  _ctx.lastTry = 0;
                  _ctx.messages = undefined;
                  _ctx.conversationId = item.chat_id;
                },
                    class: "d-flex flex-stack py-1 cursor-pointer bg-hover-light-dark bg-active-lighten border-bottom border-bottom-dotted border-gray-300 border-hover-primary"
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        (item.avatar)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: item.avatar,
                              alt: ""
                            }, null, 8, _hoisted_15))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: _normalizeClass([`bg-light-primary text-primary`, "symbol-label fs-6 fw-bolder"])
                            }, "ن"))
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("a", _hoisted_17, _toDisplayString(item.chat_id), 1),
                        _hoisted_18,
                        _createElementVNode("span", _hoisted_19, [
                          _createVNode(_component_Date, {
                            date: item.created_at
                          }, null, 8, ["date"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, _toDisplayString(item.bot.name), 1)
                    ])
                  ], 8, _hoisted_12))
                }), 128))
              ]))
            : (_openBlock(), _createBlock(_component_Notice, {
                key: 1,
                classes: "rounded-3",
                color: "primary",
                title: _ctx.translate('pay attention'),
                body: 
              _ctx.translate(
                'Since your Bot was connected to the system, no new message has been received from Autoresponder'
              )
            
              }, null, 8, ["title", "body"])),
          (_ctx.pagination && _ctx.pagination.total_pages > 1)
            ? (_openBlock(), _createBlock(_component_el_pagination, {
                key: 2,
                background: "",
                layout: "prev, pager, next",
                class: "mt-4 mb-4 text-center direction-rtl scroll",
                total: _ctx.pagination.total,
                currentPage: _ctx.pagination.current_page,
                "page-size": _ctx.pagination.per_page,
                onSizeChange: _ctx.handleSizeChange,
                onCurrentChange: _ctx.handleCurrentChange
              }, null, 8, ["total", "currentPage", "page-size", "onSizeChange", "onCurrentChange"]))
            : _createCommentVNode("", true)
        ])), [
          [_directive_loading, _ctx.loading]
        ])
      ])
    ], 4),
    _createElementVNode("div", {
      style: _normalizeStyle(`${
        _ctx.mobileUiChat === true && _ctx.activeBox === true ? 'display:none;' : ''
      }`),
      class: "flex-lg-row-fluid ms-lg-7 ms-xl-10"
    }, [
      (_ctx.activeConversation)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  (_ctx.isGroupChat)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_30))
                    : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          (_ctx.activeConversation && _ctx.activeConversation.avatar)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.activeConversation && _ctx.activeConversation.avatar,
                                alt: ""
                              }, null, 8, _hoisted_33))
                            : _createCommentVNode("", true),
                          _hoisted_34
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.activeConversation && _ctx.activeConversation.name), 1)
                        ])
                      ]))
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_component_el_tooltip, {
                    placement: "right",
                    content: _ctx.translate('Update')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-icon btn-hover-scale bg-hover-primary btn-active-light-primary",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => {
                    _ctx.lastMessageId = undefined;
                    _ctx.getMessage();
                  })
                      }, _hoisted_40)
                    ]),
                    _: 1
                  }, 8, ["content"]),
                  (_ctx.mobileUiChat === true && _ctx.activeBox === false)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-sm btn-icon btn-hover-scale bg-hover-primary btn-active-light-primary",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeBox = true))
                      }, _hoisted_42))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_43, [
              (_ctx.activeConversation.bot.status === 'ready')
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (item, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (item.type === 'out')
                          ? (_openBlock(), _createBlock(_component_MessageIn, {
                              key: 0,
                              ref_for: true,
                              ref: "messagesInRef",
                              name: _ctx.translate('Me'),
                              image: _ctx.user && _ctx.user.picture,
                              time: item.sent_at,
                              text: item.message,
                              file: item.file,
                              status: item.status
                            }, null, 8, ["name", "image", "time", "text", "file", "status"]))
                          : _createCommentVNode("", true),
                        (item.type !== 'out')
                          ? (_openBlock(), _createBlock(_component_MessageOut, {
                              key: 1,
                              ref_for: true,
                              ref: "messagesOutRef",
                              name: _ctx.activeConversation.name,
                              image: _ctx.activeConversation.avatar,
                              time: item.sent_at,
                              text: item.message,
                              file: item.file
                            }, null, 8, ["name", "image", "time", "text", "file"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ], 512))
                : (_openBlock(), _createBlock(_component_Notice, {
                    key: 1,
                    classes: "rounded-3",
                    color: "danger",
                    title: _ctx.translate('pay attention'),
                    body: ` ${_ctx.translate('Robot status')}
             ${_ctx.activeConversation.bot.name}
             ${_ctx.translate(
               'It is not ready to work in the system Therefore a message cannot be sent through this Bot please check it'
             )}`
                  }, null, 8, ["title", "body"]))
            ])), [
              [_directive_loading, _ctx.loadingMessages]
            ]),
            (_ctx.activeConversation.bot.status === 'ready')
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newMessageText) = $event)),
                    onKeydown: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.addNewMessage && _ctx.addNewMessage(...args)), ["enter"])),
                    class: "form-control form-control-flush mb-3",
                    "data-kt-element": "input",
                    placeholder: _ctx.translate('Enter your message')
                  }, null, 40, _hoisted_46), [
                    [_vModelText, _ctx.newMessageText]
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    (_openBlock(), _createBlock(_component_el_upload, {
                      key: _ctx.fileInputKey,
                      ref: "uploadRef",
                      modelValue: _ctx.files,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.files) = $event)),
                      action: _ctx.uploadActionUrl(_ctx.files),
                      "auto-upload": true,
                      multiple: false,
                      "on-success": 
                (res, file, fileList) =>
                  _ctx.uploadCallback(res, file, fileList, _ctx.index)
              ,
                      class: "upload-demo",
                      accept: _ctx.accept
                    }, {
                      tip: _withCtx(() => [
                        _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.translate("Please enter your file")), 1)
                      ]),
                      trigger: _withCtx(() => [
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("div", {
                            class: "d-flex align-items-center me-2",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.messageType = 'file'))
                          }, [
                            _createElementVNode("label", {
                              class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px",
                              "data-kt-image-input-action": "change",
                              "data-bs-toggle": "tooltip",
                              title: _ctx.translate('send file')
                            }, _hoisted_52, 8, _hoisted_50)
                          ]),
                          _createElementVNode("div", {
                            class: "d-flex align-items-center me-2",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.messageType = 'image'))
                          }, [
                            _createElementVNode("label", {
                              class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px",
                              "data-kt-image-input-action": "change",
                              "data-bs-toggle": "tooltip",
                              title: _ctx.translate('send image')
                            }, _hoisted_55, 8, _hoisted_53)
                          ]),
                          _createElementVNode("div", {
                            class: "d-flex align-items-center me-2",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.messageType = 'video'))
                          }, [
                            _createElementVNode("label", {
                              class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px",
                              "data-kt-image-input-action": "change",
                              "data-bs-toggle": "tooltip",
                              title: _ctx.translate('send video')
                            }, _hoisted_58, 8, _hoisted_56)
                          ]),
                          _createElementVNode("div", {
                            class: "d-flex align-items-center me-2",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.messageType = 'audio'))
                          }, [
                            _createElementVNode("label", {
                              class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px",
                              "data-kt-image-input-action": "change",
                              "data-bs-toggle": "tooltip",
                              title: _ctx.translate('send audio')
                            }, _hoisted_61, 8, _hoisted_59)
                          ])
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          class: "me-3 btn-sm d-none",
                          type: "success"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.translate("send to server")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "action", "on-success", "accept"])),
                    _createElementVNode("button", {
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.addNewMessage && _ctx.addNewMessage(...args))),
                      class: "btn btn-primary",
                      type: "button",
                      "data-kt-element": "send"
                    }, _toDisplayString(_ctx.translate("send")), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 4)
  ]))
}